import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Alert } from "react-bootstrap";
import "../style/login.css";
import { 
  INFO_STATEMENTS, 
  ERROR_MESSAGES,
  HTTP,
  SYSTEM_DEFAULTS
} from '../util/constants.js'
import APIFunction from "../util/api.js";

const LoginForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);
  
    try {
      const payload = {
        email: formData.email,
        password: formData.password,
      }
      const data = await APIFunction.loginRequest(payload)
    
      localStorage.setItem(SYSTEM_DEFAULTS.ACCESS_TOKEN, data.access_token);
      localStorage.setItem(SYSTEM_DEFAULTS.REFRESH_TOKEN, data.refresh_token);
      localStorage.setItem(SYSTEM_DEFAULTS.USER_CACHE, JSON.stringify(data.user));

      setSuccess(INFO_STATEMENTS.ACCOUNT_CREATED);
      setFormData({
        email: '',
        password: '',
      });

      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    } catch (error) {
      console.error('Signup error:', error);
      setError(ERROR_MESSAGES.NETWORK_ERROR);
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <section className="loginSection">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="shadow-lg border-0">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold text-secondary">Welcome Back</h2>
                  <p className="text-muted">Sign in to your Wengmack account</p>
                </div>

                {error && (
                  <Alert variant="danger" className="mb-3">
                    {error}
                  </Alert>
                )}
                
                {success && (
                  <Alert variant="success" className="mb-3">
                    {success}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                      required
                    />
                  </Form.Group>
                  
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Form.Check 
                      type="checkbox"
                      id="rememberMe"
                      label="Remember me"
                      className="text-muted"
                    />
                    <a href="/forgotPassword" className="text-primary">
                      Forgot password?
                    </a>
                  </div>

                  <div className="d-grid">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      size="lg" 
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Signing in...
                        </>
                      ) : (
                        <>
                          Sign In <i className="bi bi-box-arrow-in-right"></i>
                        </>
                      )}
                    </Button>
                  </div>
                  
                  <div className="text-center mt-3">
                    <p className="text-muted">
                      Don't have an account? <a href="/signUp" className="text-primary">Sign up</a>
                    </p>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LoginForm;
